module.exports = __webpack_public_path__ + "static/media/Question.6a5a1e4f.svg";